import {
  isContactImportJobTerminalStatus,
  shouldContinueContactImportPolling,
  shouldPollContactImportJob,
  shouldShowContactImportProgressToast,
  type ContactImportJobDto,
} from "@multi-chat/shared";

export const CONTACT_IMPORT_JOB_POLL_MS = 2000;
export const CONTACT_IMPORT_WATCH_EVENT = "contact-import-watch";

export type ContactImportWatchDetail = {
  jobId: string;
};

export type ContactImportPollDecision = {
  pollJob: boolean;
  showToast: boolean;
  stop: boolean;
};

export function decideContactImportPoll(
  job: ContactImportJobDto | null,
): ContactImportPollDecision {
  if (!job || isContactImportJobTerminalStatus(job.status)) {
    return { pollJob: false, showToast: false, stop: true };
  }
  return {
    pollJob: shouldPollContactImportJob(job.status),
    showToast: shouldShowContactImportProgressToast(job.status),
    stop: !shouldContinueContactImportPolling(job),
  };
}

export function dispatchContactImportWatch(jobId: string): void {
  window.dispatchEvent(
    new CustomEvent<ContactImportWatchDetail>(CONTACT_IMPORT_WATCH_EVENT, {
      detail: { jobId },
    }),
  );
}
